import React from 'react'
import PropTypes from 'prop-types'

import { noop } from 'lodash'

import { WarningContainedButton } from '../../LegacyButtons'
import { ConfirmationDialog } from '@scoir/modals'

import api from 'common/api'

export class Modal extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    eventId: PropTypes.string.isRequired,
    highSchoolName: PropTypes.string.isRequired,
    onEventChange: PropTypes.func.isRequired,
  }
  static defaultProps = {
    show: false,
  }
  withdraw() {
    const { eventId, onClose, onEventChange } = this.props
    api
      .delete(`/api/highschools/visits/${eventId}/register`)
      .then(() => {
        onEventChange()
        onClose()
      })
      .catch(noop)
  }
  render() {
    return (
      <ConfirmationDialog
        open={this.props.show}
        headerText="Confirm Request Withdrawal"
        onClose={this.props.onClose}
        onConfirm={() => this.withdraw()}
      >
        <span>Are you sure you want to withdraw this request for a visit?</span>
        <div className="shared-information-label">
          <strong>{this.props.highSchoolName}</strong> will be notified that you no longer wish to visit at this time.
        </div>
      </ConfirmationDialog>
    )
  }
}
export class Trigger extends React.Component {
  static propTypes = {
    onOpen: PropTypes.func.isRequired,
  }
  render() {
    return (
      <WarningContainedButton
        variant="contained"
        color="secondary"
        size="small"
        onClick={() => this.props.onOpen()}
      >
        Withdraw Request
      </WarningContainedButton>
    )
  }
}
